import React, { useState, useEffect } from "react";
import "./LoginSignup.css";
import { Redirect } from "react-router";
import {
  registrationsOTP,
  GetSettingWorkSpaceByUserID,
} from "../../global/utils";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import * as AppUrls from "../../constants/AppUrls";
import * as Constants from "../../constants/Constants";

import { useTranslation } from "react-i18next";
import * as utils from "../../global/utils";

import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../store/actionTypes";
import * as Helpers from "../../global/Helpers";
import i18next from "i18next";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { Shift } from "react-bootstrap-icons";
import SpinnersLoadingSIP from "../SpinnersLoadingSIP/SpinnersLoadingSIP";
import { otpSessionId } from "./Login.js"; 
toast.configure();

function OTP(props) {
  const [input, setInput] = useState("");
  const [layoutName, setLayoutName] = useState("default");

  const [keyboardLayout, setKeyboardLayout] = useState(
    generateKeyboardLayout()
  );
  const [isDisabled, setIsDisabled] = useState(true);
  const [timer, setTimer] = useState(60); // 60 seconds

  useEffect(() => {
    let interval = null;

    if (isDisabled) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            setIsDisabled(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isDisabled]);

  function generateKeyboardLayout() {
    const letters = "qwertyuiopasdfghjklzxcvbnm";
    const number = "1234567890";
    const lettersCaps = "QWERTYUIOPASDFGHJKLZXCVBNM";
    const lettersCapsNum = "!@#$%^&*()";

    const shuffledLetters = shuffle(letters.split(""));
    const shuffledNumber = shuffle(number.split(""));
    const shuffledlettersCaps = shuffle(lettersCaps.split(""));
    const shuffledlettersCapsNum = shuffle(lettersCapsNum.split(""));

    const layout = [
      "1 2 3 4 5 6 7 8 9 0",
      "q w e r t y u i o p {bksp}",
      "a s d f g h j k l",
      "{shift} z x c v b n m {shift}",
      "{capslock} {space} {enter}",
    ];
    const shiftLayout = [
      "! @ # $ % ^ & * ( )",
      "Q W E R T Y U I O P {bksp}",
      "A S D F G H J K L",
      "{shift} Z X C V B N M {shift}",
      "{capslock} {space} {enter}",
    ];
    const capsLayout = [
      "! @ # $ % ^ & * ( )",
      "Q W E R T Y U I O P",
      "A S D F G H J K L",
      "{shift} Z X C V B N M {bksp}",
      "{capslock} {space} {enter}",
    ];

    for (let i = 0; i < layout.length; i++) {
      const row = layout[i];
      layout[i] = row
        .split(" ")
        .map((key) => {
          if (
            key === "{bksp}" ||
            key === "{shift}" ||
            key === "{space}" ||
            key === "{capslock}" ||
            key === "{enter}"
          ) {
            return key;
          } else if (layoutName === "default") {
            return i > 0 ? shuffledLetters.pop() : shuffledNumber.pop();
          } else if (layoutName === "shift") {
            return i > 0
              ? shuffledlettersCaps.pop()
              : shuffledlettersCapsNum.pop();
          }
        })
        .join(" ");
    }

    // for (let i = 0; i < shiftLayout.length; i++) {
    //   const row = shiftLayout[i];
    //   shiftLayout[i] = row
    //     .split(" ")
    //     .map((key) => {
    //      //
    //       if (key === "{bksp}" || key === "{shift}" || key === "{space}" || key === "{capslock}" || key === "{enter}" ) {
    //         return key;
    //       } else {
    //         return  i > 0 ?  shuffledlettersCaps.pop() : shuffledlettersCapsNum.pop()
    //       }
    //     })
    //     .join(" ");
    // }

    // for (let i = 0; i < capsLayout.length; i++) {
    //   const row = capsLayout[i];
    //   capsLayout[i] = row
    //     .split(" ")
    //     .map((key) => {
    //       if (key === "{bksp}" || key === "{shift}" || key === "{space}" || key === "{capslock}" || key === "{enter}" ) {
    //         return key;
    //       } else {
    //         return shuffledlettersCaps.pop();
    //       }
    //     })
    //     .join(" ");
    // }

    return { default: layout, shift: shiftLayout, caps: capsLayout };
  }

  function shuffle(array) {
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
  const onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
    if (button === "{capslock}") handleCapsLock();
    if (button === "{space}") handleSpace();
    if (button === "{bksp}") handleBackspace();
    // Add more custom handlers for special characters here
  };
  const handleShift = () => {
    setLayoutName(layoutName === "default" ? "shift" : "default");
  };

  const handleCapsLock = () => {
    setLayoutName(layoutName === "default" ? "shift" : "default");
  };

  const handleSpace = () => {
    setInput(input + " ");
  };

  const handleBackspace = () => {
    setInput(input.slice(0, -1));
  };

  const abortController = new AbortController();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [otp, setOtp] = useState("");
  const [otpSIB, setOtpSIB] = useState(Array(5).fill(""));
  const [redirect, setRedirect] = useState(null);
  const [visible, setVisible] = useState(false);
  const [otpType, setotpType] = useState("password");

  // const errorNotify = (message) => {
  //   toast.error(message, {
  //     position: toast.POSITION.BOTTOM_CENTER,
  //     hideProgressBar: true,
  //     autoClose: Constants.errorNotifyDuration
  //   });
  // };

  // const successNotify = () => {
  //   toast.success("Successful Login!", {
  //     position: toast.POSITION.BOTTOM_CENTER,
  //     hideProgressBar: true,
  //     autoClose: Constants.successNotifyDuration
  //   });
  // };
  const getUserSettings = () => {
    let response = GetSettingWorkSpaceByUserID();
    response
      .then((response) => {
        //
        let data = response.data[0];
        if (
          data.WorkSpaceSettings !== undefined &&
          data.WorkSpaceSettings !== null &&
          data.WorkSpaceSettings !== ""
        ) {
          var res = JSON.parse(data.WorkSpaceSettings);

          localStorage.setItem("selectedProfile", res.selectedProfile);
          localStorage.setItem("theme", res.theme);
          localStorage.setItem("UserSettings", data.WorkSpaceSettings);
          // if (i18n.language === "ar" && res.lang === "en")
          //   props.changeLanguageNew()
          // else if (i18n.language === "en" && res.lang === "ar")
          //   props.changeLanguageNew()

          dispatch({
            type: actions.SELECT_PREFERRED_SYMBOL,
            payload: {
              PreferredSymbol: res.PreferredSymbol,
            },
          });

          dispatch({
            type: actions.SELECT_PREFERRED_EXCHANGE,
            payload: {
              PreferredExchange: res.PreferredExchange,
            },
          });

          dispatch({
            type: actions.UPDATE_ENABLE_EXPAND_ROW,
            payload: {
              EnableExpandRow: res.expandRow === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_TRADE_TICKER,
            payload: {
              EnableTradeTicker: res.tradeTicker === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_ROUND_TICKER,
            payload: {
              EnableRoundTicker: res.RoundTicker === "Y" ? true : false,
            },
          });
          saveSettings(data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  function saveSettings(data) {
    var res = JSON.parse(data.WorkSpaceSettings);
    let LanguageSelectedFromLogin = localStorage.getItem(
      "LanguageSelectedFromLogin"
    );
    let isLanguageSelectedFromLogin = localStorage.getItem(
      "isLanguageSelectedFromLogin"
    );
    var lang = "";
    if (isLanguageSelectedFromLogin === "true")
      lang = LanguageSelectedFromLogin;
    else lang = res.lang;
    let settings = {
      lang: lang,
      theme: res.theme,
      //theme: '',
      expandRow: res.expandRow,
      PreferredSymbol: res.PreferredSymbol,
      PreferredExchange: res.PreferredExchange,
      selectedProfile: res.selectedProfile,
      tradeTicker: res.tradeTicker,
      RoundTicker: res.RoundTicker,
    };

    if (data !== undefined && data !== null) {
      let postdata = {
        profileUniqueID: data.profileUniqueID,
        ProfileID: data.ProfileID,
        ProfileName: data.ProfileName,
        ProfileNameAr: data.ProfileNameAr,
        ProfileSettings: data.ProfileSettings,
        WorkSpaceSettings: JSON.stringify(settings),
        WebCode: localStorage.getItem("WebCode"),
      };
      var updateWorkSpaceSettings = utils.UpdateUserProfileSettings(postdata);
      updateWorkSpaceSettings
        .then((response) => {
          if (response.data) {
            // console.log("Settings Successfully Updated");
            // this.props.setUserSettings(settings)
            localStorage.setItem("UserSettings", JSON.stringify(settings));

            if (i18n.language === "ar" && settings.lang === "en")
              props.changeLanguageNew();
            else if (i18n.language === "en" && settings.lang === "ar")
              props.changeLanguageNew();
          } else {
            console.log(
              "Unsuccessfull Update Settings, please contact Administrator"
            );
          }
        })
        .finally(() => {
          if (abortController) abortController.abort();
        })
        .catch((error) => {
          console.log(
            "Unsuccessfull Update Settings, please contact Administrator"
          );
          if (abortController) abortController.abort();
        });
    }
  }

  function validate() {
    const companyName = localStorage
      .getItem(Constants.localStorageConstants.company_name)
      ?.toUpperCase();

    if (companyName !== "SIFS") {
      if (!otp) {
        Helpers.errorNotify(t("Please_enter_OTP"), i18n.language);
        return false;
      }
    } else {
      if (otpSIB.some((val) => val === "")) {
        Helpers.errorNotify(t("Please_enter_OTP"), i18n.language);
        return false;
      }
    }

    // var DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
    // if (
    //   DeviceConfigs !== null &&
    //   DeviceConfigs !== undefined &&
    //   localStorage
    //     .getItem(Constants.localStorageConstants.company_name)
    //     .toUpperCase() === "SIFS"
    // ) {
    //   if (Number(DeviceConfigs.Tokenlength) !== otp.length) {
    //     if (Number(DeviceConfigs.Tokenlength) < otp.length) {
    //       var msg =
    //         i18next.language === "ar"
    //           ? " لا ينبغي أن يكون الرمز المؤقت أكثر من " +
    //             Number(DeviceConfigs.Tokenlength) +
    //             " خانات "
    //           : "OTP should not be more than " +
    //             Number(DeviceConfigs.Tokenlength) +
    //             " digits";
    //       Helpers.errorNotify(msg, i18next.language);
    //     } else if (Number(DeviceConfigs.Tokenlength) > otp.length) {
    //       var msg =
    //         i18next.language === "ar"
    //           ? " لا ينبغي أن يكون الرمز المؤقت أقل من " +
    //             Number(DeviceConfigs.Tokenlength) +
    //             " خانات "
    //           : "OTP should not be less than " +
    //             Number(DeviceConfigs.Tokenlength) +
    //             " digits";
    //       Helpers.errorNotify(msg, i18next.language);
    //     }
    //     return false;
    //   }
    // }
    return true;
  }

  function submit(e) {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    setVisible(true);

    var isIPOQuickSell =
      localStorage
        .getItem(Constants.localStorageConstants.EnableIPOQuickSell)
        .toUpperCase() === "TRUE" &&
      localStorage.getItem("IsNormalLogin") === "false"
        ? "Y"
        : "N";
    // var passwordToOTp =
    //   localStorage.getItem("passwordToOTp") === "false"
    //     ? ""
    //     : localStorage.getItem("passwordToOTp");
   const encPass = otpSessionId ? otpSessionId.value : ""
    var passwordToOTp =
      encPass === "false"
        ? ""
        : encPass;
        
    var isAuthorizeOnly =
      encPass === "false" ? "Y" : "N";
    // var isAuthorizeOnly =
    //   localStorage.getItem("passwordToOTp") === "false" ? "Y" : "N";

    var otpFinal =
      localStorage
        .getItem(Constants.localStorageConstants.company_name)
        ?.toUpperCase() === "SIFS"
        ? otpSIB[0] + otpSIB[1] + otpSIB[2] + otpSIB[3] + otpSIB[4]
        : otp;
    var response = registrationsOTP(
      localStorage.getItem("username"),
      otpFinal,
      "",
      passwordToOTp,
      "",
      "",
      isAuthorizeOnly,
      isIPOQuickSell
    );

    //console.log(response);
    response
      .then((response) => {
        setVisible(false);

        let responseJson = response.data;
        let webcode = responseJson["WebCode"];
        let isFirstLoggedIn = response.data["IsFirstLogin"]; //localStorage.getItem("isFirstLoggedIn");

        if (
          webcode !== undefined &&
          webcode !== null &&
          webcode !== "" &&
          webcode !== "-1" &&
          responseJson["Status"] === "0"
        ) {
          if (isFirstLoggedIn === "Y") {
            localStorage.setItem("WebCode", webcode);
            localStorage.setItem("loginFirst", true);
            localStorage.setItem("validValue", otp);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);

            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("user", JSON.stringify(response.data));
            //localStorage.setItem("IsNormalLogin", true);

            getUserSettings();
            setRedirect(AppUrls.changePassword);

            return;
          } else {
            Helpers.successNotify(t("Successful_Login!"), i18next.language);
            localStorage.setItem("WebCode", webcode);
            localStorage.setItem("loginFirst", true);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
            getUserSettings();
            localStorage.setItem("user", JSON.stringify(response.data));

            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            //localStorage.setItem("IsNormalLogin", true);
            localStorage.setItem("tries", response.data["tries"]);
            // if (response.data["isTermsAndConditions"] === "N" &&
            //   ((localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE" && localStorage.getItem("IsNormalLogin") === "false") || localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS")) {
            //   setRedirect(AppUrls.TermsAndConditions);

            // }
            // else {
            setRedirect(AppUrls.trading);
            //}
          }
        } else {
          if (
            localStorage
              .getItem(Constants.localStorageConstants.company_name)
              .toUpperCase() === "SIFS"
          ) {
            setOtp("");
          }
          if (responseJson["Status"] === "-6") {
            Helpers.errorNotify(t("userLocked"), i18next.language);
          } else if (responseJson["Status"] === "-4") {
            Helpers.errorNotify(responseJson["ErrorMsg"], i18next.language);
          } else Helpers.errorNotify(t("invalidOTP"), i18next.language);
        }
      })
      .catch((error) => {
        setVisible(false);
        console.log("error", error);
        Helpers.errorNotify(error.message, i18n.language);
      });
  }
  const callLogOff = () => {
    //
    // props.setIsLoaderVisible(true);
    //console.log("logging out...");
    let logOffResponse = utils.logOff();
    logOffResponse
      .then((response) => {
        // props.setIsLoaderVisible(false);
        //console.log("Logged Off", response)
        if (response.status === 200) {
          localStorage.removeItem("user");
          localStorage.removeItem("ExpiredDocument");
          let UserName = localStorage.getItem("username");
          let RememberMe = localStorage.getItem("isRememberMe");
          let language = localStorage.getItem("language");

          let Comapnyname = localStorage.getItem(
            Constants.localStorageConstants.company_name
          );
          var prev = Helpers.getPreviousConfig();

          if (RememberMe === "true") {
            localStorage.clear();
            localStorage.setItem("isRememberMe", true);
            localStorage.setItem("username", UserName);
            localStorage.setItem("language", language);

            localStorage.setItem(
              Constants.localStorageConstants.company_name,
              Comapnyname
            );
          } else {
            localStorage.clear();
            localStorage.setItem("language", language);

            localStorage.setItem(
              Constants.localStorageConstants.company_name,
              Comapnyname
            );
          }
          Helpers.SetpreviosConfig(prev);
          setRedirect(AppUrls.login);
          //   setState({ redirect: AppUrls.login }, () => {
          //     disconnectSignalr();
          //   });
        }
      })
      .catch((error) => {
        //props.setIsLoaderVisible(false);
        //console.log("error", error);
      });
  };

  var hideLoader = "";
  if (visible) {
    hideLoader = "";
  } else {
    hideLoader = "hide-loader";
  }

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  const onChange = (otp) => {
    setOtp(otp);
  };

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = otpSIB.map((digit, i) => (i === index ? value : digit));
      setOtpSIB(newOtp);

      // Move to next input if current input is filled
      if (value && index < otpSIB.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      // Move to previous input if current input is empty and not the first input
      if (!value && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };
  const reSendOTP = () => {
    var url =
      Constants.reSendUserToken +
      localStorage.getItem("username") +
      "/" +
      localStorage.getItem("WebCode");
    var reSendUserToken = utils.reSendUserToken(url);
    reSendUserToken
      .then((response) => {
        if (response.data) {
          Helpers.successNotify(t("ReSendOTPMSG"), i18n.language);
          setIsDisabled(true);
          setTimer(60); // Reset the timer to 60 seconds
        } else {
          Helpers.errorNotify(t("somethingwentwrong"), i18n.language);
        }
      })
      .catch((error) => {
        Helpers.errorNotify(t("somethingwentwrong"), i18n.language);
      });
  };
  return (
    <div className="AuthCont">
      <form name="form" className="OTP-Form">
        <div className="center">
          <div className="form-group">
            {/* <input
              className="input-textbox"
              type="password"
              name="password"
              placeholder={t("otpDesc")}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            /> */}
          </div>
        </div>

        {localStorage
          .getItem(Constants.localStorageConstants.company_name)
          ?.toUpperCase() === "SIFS" ? (
          // <div className="form-group container-input-with-password OTPSIBAr" style={{marginInline:i18n.language === "ar"   ? "0px":"8%"}}>
          <div className="form-group container-input-with-password OTPSIBAr" >
            {otpSIB.map((_, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength="1"
                value={otpSIB[index]}
                onChange={(e) => handleChange(e, index)}
                className="otp-input"
                    autoFocus={index === 0}
              />
            ))}
          </div>
        ) : (
          <div className="form-group container-input-with-password">
            <input
              className="input-textbox"
              type={otpType}
              name="password"
              placeholder={t("otpDesc")}
              value={otp}
              maxLength={
                localStorage
                  .getItem(Constants.localStorageConstants.company_name)
                  .toUpperCase() === "SIFS"
                  ? "5"
                  : "100"
              }
              onChange={(e) => {
                // setOtp(e.target.value);
                const value = e.target.value;
                const numericOnly = value.replace(/\D/g, "");

                var last =
                  localStorage
                    .getItem(Constants.localStorageConstants.company_name)
                    .toUpperCase() === "SIFS"
                    ? numericOnly
                    : value;

                setOtp(last);
              }}
              autoComplete="new-password"
              disabled={
                localStorage
                  .getItem(Constants.localStorageConstants.company_name)
                  .toUpperCase() === "PIONEERS" ||
                localStorage
                  .getItem(Constants.localStorageConstants.company_name)
                  .toUpperCase() === "BOOM"
                  ? true
                  : false
              }
            />
            <i
              className={
                otpType === "password" ? "fa fa-eye-slash" : "fa fa-eye"
              }
              aria-hidden="true"
              style={{
                fontSize: "20px",
                cursor: "pointer",
                right: i18n.language === "en" ? "21px" : "",
                left: i18n.language === "en" ? "" : "21px",
                position: "absolute",
                top: "17px",
                color: "black",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (otpType === "password") {
                  setotpType("text");
                } else {
                  setotpType("password");
                }
              }}
            ></i>
          </div>
        )}

        {localStorage
          .getItem(Constants.localStorageConstants.company_name)
          .toUpperCase() === "PIONEERS" ||
        localStorage
          .getItem(Constants.localStorageConstants.company_name)
          .toUpperCase() === "BOOM" ? (
          <div>
            <div className="mt-2 keyboard-container KeyboardLogin">
              <Keyboard
                layoutName={layoutName}
                layout={keyboardLayout}
                onChange={onChange}
                onKeyPress={onKeyPress}
              />
            </div>
          </div>
        ) : null}

        {localStorage
          .getItem(Constants.localStorageConstants.company_name)
          .toUpperCase() === "SIFS" ? (
          <div
            style={{
              display: "flex",
              marginBottom: "15px",
              marginTop: "15px",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              className="btn custom-btn-cancel mr-2 ml-2"
              style={{ width: "43%" }}
              disabled={isDisabled}
              onClick={(event) => {
                event.preventDefault();
                reSendOTP();
              }}
            >
              {t("ReSendOTP")} {"  "}{" "}
              {i18n.language === "ar"
                ? isDisabled && `  ${timer} ثانية`
                : isDisabled && `in  ${timer}s`}
            </button>

            <button
              className="btn customBtn mr-2 ml-2"
              style={{ contain: "content", width: "45%", color: "#fff" }}
              onClick={submit}
            >
              {t("sendOtp")}
            </button>
          </div>
        ) : (
          <div className="form-group form-group-btns center">
            <button
              className="auth-btns btn btn-primary  customBtn"
              style={{ width: "60%" }}
              onClick={submit}
            >
              {t("sendOtp")}
            </button>
          </div>
        )}
        <div>
          <button
            className={"link WelcomeMessageDiv"}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              display:
                localStorage.getItem(
                  Constants.localStorageConstants.company_name
                ) === "HORIZON"
                  ? "block"
                  : "block",
            }}
            onClick={(event) => {
              event.preventDefault();
              // setRedirect(AppUrls.login);
              callLogOff();
              //localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) :  setRedirect(AppUrls.login);
            }}
          >
            {t("cancelForgotPassword")}
          </button>


          
        </div>
      </form>

      {localStorage.getItem(Constants.localStorageConstants.company_name) !==
      "SIFS" ? (
        <div
          className={"center-loader loaderCss " + hideLoader}
          style={{ backgroundColor: "#FFFFFFD9" }}
        >
          <Loader
            type="Bars"
            color="#00BFFF"
            height={100}
            width={100}
            visible={visible}
          />
        </div>
      ) : (
        <div
          className={" center-loader " + hideLoader}
          style={{ height: "100%", width: "100%" }}
        >
          <SpinnersLoadingSIP />
        </div>
      )}
    </div>
  );
}

export default OTP;
